import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  text: {
    color: theme.palette.text.primary,
    opacity: 0.7,
  },
}));

export default useStyles;
